import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const header_socials = () => {
  return (
    <div className='header_socials'>
        <a href="https://www.linkedin.com/in/kshitij-jaiswal-b5664b196/" target="_blank"><BsLinkedin size={30}/></a>
        <a href="https://github.com/Kshitij77" target="_blank"><FaGithub size={30}/></a>
    </div>
  )
}

export default header_socials